import { createContext } from "react";

const Navigate_Context = createContext();

export default Navigate_Context;